import { DefectListItemDTO, UpdateDefectsCommand } from 'src/app/DTOs/DefectDTO';import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subject, debounceTime, takeUntil } from 'rxjs';

import { MasterDataService } from 'src/app/Services/master-data.service';
import { PrimeNgModule } from 'src/app/Shared/prime-ng/prime-ng.module';

type SaveState = 'idle' | 'saving' | 'saved' | 'error';

@Component({
  selector: 'app-defect-card',
  standalone: true,
  imports: [PrimeNgModule, CommonModule, FormsModule],
  templateUrl: './defect-card.component.html',
  styleUrl: './defect-card.component.css'
})
export class DefectCardComponent implements OnInit, OnDestroy {
  @Input({ required: true }) defect!: DefectListItemDTO;

  // customerId required for backend scoping
  @Input({ required: true }) customerId!: number;

  @Output() openChildren = new EventEmitter<DefectListItemDTO>();
  @Output() changed = new EventEmitter<void>();

  edit!: DefectListItemDTO;
  saveState: SaveState = 'idle';

  private autosave$ = new Subject<void>();
  private destroy$ = new Subject<void>();

  constructor(private masterData: MasterDataService) { }

  ngOnInit(): void {
    // Local edit copy (avoid mutating parent list reference)
    this.edit = { ...this.defect };

    // Debounced autosave for text/number changes
    this.autosave$
      .pipe(debounceTime(400), takeUntil(this.destroy$))
      .subscribe(() => this.save());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /** Call on (input) for text/number fields */
  queueSave(): void {
    this.autosave$.next();
  }

  /** Call on chip click */
  saveNow(): void {
    this.save();
  }

  /** Header click: ALWAYS navigate */
  openFromHeader(): void {
    this.openChildren.emit(this.defect);
  }

  private save(): void {
    // UI rule: only leaf defects can have severity
    if (this.defect.hasChildren) {
      this.edit.critical = false;
      this.edit.major = false;
      this.edit.minor = false;
    }

    const cmd: UpdateDefectsCommand = {
      customerId: this.customerId,
      defectId: this.edit.defectId,
      parentId: this.edit.parentId ?? null,
      titleDE: (this.edit.titleDE ?? '').trim(),
      titleEN: (this.edit.titleEN ?? '').trim(),
      number: this.edit.number ?? 0,
      critical: !!this.edit.critical,
      major: !!this.edit.major,
      minor: !!this.edit.minor,
      rowVersion: this.edit.rowVersion
    };

    this.saveState = 'saving';

    this.masterData.updateDefect(cmd).subscribe({
      next: () => {
        this.saveState = 'saved';
        this.changed.emit();
      },
      error: (err) => {
        this.saveState = 'error';
        // eslint-disable-next-line no-console
        console.error('Defect save failed', err);
      }
    });
  }
}